import { type ILogoConfig, type LogoLayouts, logoLayouts } from "@/types";

export const logoLayoutConfig: {
  [key in LogoLayouts]: ILogoConfig;
} = {
  [logoLayouts.VERTICAL]: {
    width: 96,
    height: 128,
    l: { x: 8.1397, y: 120.031 },
    t: { x: 25.9528, y: 94.0537 },
    k: { x: 74.2575, y: 102.564 },
  },
  [logoLayouts.HORIZONTAL]: {
    width: 210,
    height: 70,
    // shifted the values by x: 98 y: -70
    l: { x: 106.1397, y: 50.031 },
    t: { x: 123.9528, y: 24.0537 },
    k: { x: 172.2575, y: 32.564 },
  },
};
